import { sectorsInfoList } from 'helper/helper';

const sectorsInfo = sectorsInfoList();

const SectorOfActivity = ({ sectors, selectedSector, onSelectSector }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {sectors.map((key) => (
        <div
          key={key}
          className={`flex justify-center items-center border rounded-lg gap-2 w-[150px] h-[97px] cursor-pointer ${
            selectedSector === key
              ? 'bg-yellow-50 border-yellow-500'
              : 'hover:bg-gray-100'
          }`}
          onClick={() => onSelectSector(key)}
        >
          <div className="flex flex-col items-center text-center">
            <div className="text-3xl">{sectorsInfo[key]?.icon || '❓'}</div>
            <div>{sectorsInfo[key]?.name || key}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SectorOfActivity;
